import React, { useEffect, useState } from 'react';

const Timer = ({ initialTime, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (timeLeft <= 0) {
      onExpire?.(null);
      setTimeLeft(initialTime);
      return;
    }

    const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    return () => clearTimeout(timer);
  }, [timeLeft, initialTime, onExpire]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const progress = (timeLeft / initialTime) * 100;

  return (
    <div>
      <div
        style={{
          position: 'absolute',
          top: '55%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <svg width='50' height='50' style={{ transform: 'rotate(-90deg)' }}>
          <circle cx='25' cy='25' r='20' stroke='#fff' strokeWidth='4' fill='none' />
          <circle
            cx='25'
            cy='25'
            r='20'
            stroke='#1BE29A'
            strokeWidth='4'
            strokeDasharray='125.6' /* 2 * π * r = 125.6 */
            strokeDashoffset={(125.6 * (100 - progress)) / 100}
            fill='none'
          />
        </svg>
      </div>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#fff',
        }}
      >
        {formatTime(timeLeft)}
      </div>
    </div>
  );
};

export default Timer;
